import React from 'react'

const Banner = (props) => (
    <section id="banner" className="major">
        <div className="inner">
            <header className="major megrim">
                <h1>Jonna Bonnette</h1>
            </header>
            <div className="content">
                <p>
                  Elevate your marketing campaigns and connect with your audience through social media and traditional advertising.
                </p>
                <ul className="actions">
                    <li><a href="#contact" className="button next scrolly">Let's Talk</a></li>
                </ul>
            </div>
        </div>
    </section>
)

export default Banner
